import React, { useEffect, useState } from "react";
import axios from "axios";
import ResultCard from "./ResultCard";
import "./ResultCardData.css";

const ResultCardData = () => {
  const headerInfo = {
    website: "SATTAWALAONLINE.COM",
    tagline: "SATTA WALA | SATTA RESULT | SATTA RECORD",
  };

  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  // Live date/time update
  useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();

      const formattedDate = new Intl.DateTimeFormat("en-IN", {
        day: "2-digit",
        month: "long",
        year: "numeric",
        timeZone: "Asia/Kolkata",
      }).format(now);

      const formattedTime = new Intl.DateTimeFormat("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      }).format(now);

      setCurrentDate(formattedDate);
      setCurrentTime(formattedTime);
    };

    updateDateTime();
    const timer = setInterval(updateDateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  // Fetch API Data
  useEffect(() => {
    const fetchResults = async () => {
      try {
        const response = await axios.get("https://sattawalaonline.com/api/data");
        if (Array.isArray(response.data)) {
          setResults(response.data);
        } else {
          setResults([]);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
        setResults([]);
      } finally {
        setLoading(false);
      }
    };

    fetchResults();

    // Optional: auto-refresh every 30s
    const interval = setInterval(fetchResults, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="result-section">
      {/* Header */}
      <div className="result-block-header">
        <h2>{headerInfo.website}</h2>
        <p>{headerInfo.tagline}</p>
      </div>

      {/* Loader */}
      {loading && <p className="loading-text">Loading results...</p>}

      {/* Cards */}
      <div className="result-card-data">
        {!loading && results.length > 0 ? (
          results.map((item) => (
            <ResultCard
              key={item.id}
              dateTime={`${currentDate} ${currentTime}`}
              gameName={item.place}
              result={item.data || "WAIT"}
              lastUpdated={item.updated_at_local}
            />
          ))
        ) : (
          !loading && <p className="no-data-text">No results available</p>
        )}
      </div>
    </div>
  );
};

export default ResultCardData;
